export enum DirectionEnum {
  asc = 'asc',
  desc = 'desc',
}
